module.exports = __webpack_public_path__ + "img/paytable_icon.c3e5857d.svg";